import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d74d39a8")

_pushScopeId("data-v-d74d39a8")
const _hoisted_1 = { class: "col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12" }
const _hoisted_2 = { class: "item-wallet p-4 m-3 pointer" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-1 mr-3" }
const _hoisted_5 = {
  key: 0,
  class: "far fa-credit-card fa-2x mr-2"
}
const _hoisted_6 = {
  key: 1,
  class: "fas fa-wallet fa-2x mr-2"
}
const _hoisted_7 = { class: "col-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 text-left" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { class: "col-12 text-left" }
const _hoisted_12 = { class: "mb-0 text-box" }
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12 text-center" }
const _hoisted_16 = { class: "col-12 text-center" }
const _hoisted_17 = {
  key: 0,
  class: "fas fa-check-circle"
}
const _hoisted_18 = {
  key: 1,
  class: "fas fa-exclamation-triangle"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      style: {"text-decoration":"none"},
      to: { name: 'bank.account.detail', params: { id: _ctx.item.id } }
    }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              (_ctx.item.type === 1)
                ? (_openBlock(), _createBlock("i", _hoisted_5))
                : _createCommentVNode("", true),
              (_ctx.item.type === 2)
                ? (_openBlock(), _createBlock("i", _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("h6", _hoisted_10, _toDisplayString(_ctx.item.type === 1
                      ? _ctx.item.bankName || 'Bank Account'
                      : _ctx.item.accountName || 'Crypto Account'), 1)
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("p", _hoisted_12, _toDisplayString(_ctx.item.type === 1
                      ? _ctx.formatBankNumber(_ctx.item.bankAccountNumber)
                      : _ctx.formatCryptoAddress(_ctx.item.cryptoAddress)), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.item.currencyId), 1),
                _createVNode("div", _hoisted_16, [
                  (_ctx.item.isActive)
                    ? (_openBlock(), _createBlock("i", _hoisted_17))
                    : (_openBlock(), _createBlock("i", _hoisted_18))
                ])
              ])
            ])
          ])
        ], 512), [
          [
            _directive_tooltip,
            _ctx.item.isActive ? '' : 'Your account is being verified',
            void 0,
            { top: true }
          ]
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
})